import { NgModule } from "@angular/core";
import { ToFuncIdentityPipe } from "src/app/pipes/to-func-identity.pipe";
import { AbsoluteUrlPipe } from "./aboslute-url.pipe";
import { AgePipe } from "./age.pipe";
import { ArchiveIconPipe } from "./archive-icon.pipe";
import { BuildUrlWithFacilityPipe } from "./build-url-with-facility.pipe";
import { CustomerNominativePipe } from "./customer-nominative.pipe";
import { DurationPipe } from "./duration.pipe";
import { FileSizePipe } from "./filesize.pipe";
import { FormatAddressPipe } from "./format-address.pipe";
import { GravatarUrlPipe } from "./gravatar-url.pipe";
import { MentionsPipe } from "./mentions.pipe";
import { PrintAddressPipe } from "./print-address.pipe";
import { RandomArrayPipe } from "./random-array.pipe";
import { TodayOrDatePipe } from "./today-or-date.pipe";
import { DayjsPipe } from "src/app/pipes/dayjs.pipe";
import { DayjsParsePipe } from "src/app/pipes/dayjs-parse.pipe";
import { WeightPipe } from "./weight.pipe";
import { MedicalImageViewerDirective } from "src/app/pipes/medical-image-viewer.directive";
import { OpenHealthRecordTitlePipe } from "src/app/pipes/open-health-record-title.pipe";
import { IconByFileTypePipe } from "src/app/pipes/icon-by-file-type.pipe";
import { SpeciesIconPipe } from "src/app/pipes/species-icon.pipe";
import { ColorByStringPipe } from "src/app/pipes/color-by-string.pipe";
import { ColorByIndexPipe } from "src/app/pipes/color-by-index.pipe";
import { ColorByIdPipe } from "src/app/pipes/color-by-id.pipe";
import { InitialsPipe } from "src/app/pipes/initials.pipe";
import { TextToHtmlPipe } from "src/app/pipes/text-to-html.pipe";
import { TruncatePipe } from "src/app/pipes/truncate.pipe";
import { HtmlToTextPipe } from "src/app/pipes/html-to-text.pipe";
import { PhonePipe } from "src/app/pipes/phone.pipe";
import { DateDiffPipe } from "src/app/pipes/date-diff.pipe";
import { SafeHtmlPipe } from "src/app/pipes/safe-html.pipe";
import { AbsPipe } from "src/app/pipes/abs.pipe";
import { TruncateMiddlePipe } from "src/app/pipes/truncate-middle.pipe";
import { CanPipe } from "src/app/pipes/can.pipe";
import { StatePipe } from "src/app/pipes/state.pipe";
import { CanBeActivatedPipe } from "src/app/pipes/can-be-activated.pipe";
import { NameDrugsPipe } from "./nameDrugs.pipe";
import { FirstLetterPipe } from "src/app/pipes/first-letter.pipe";
import { MoneyPipe } from "src/app/pipes/money.pipe";
import { ReplacePipe } from "src/app/pipes/replace.pipe";
import { AttachmentIsSignedPipe } from "src/app/pipes/attachment-is-signed.pipe";
import { AttachmentIsSignablePipe } from "src/app/pipes/attachment-is-signable.pipe";
import { StripHtmlPipe } from "src/app/pipes/strip-html.pipe";

@NgModule({
  imports: [],
  exports: [
    ArchiveIconPipe,
    BuildUrlWithFacilityPipe,
    DurationPipe,
    FileSizePipe,
    RandomArrayPipe,
    TodayOrDatePipe,
    PrintAddressPipe,
    AbsoluteUrlPipe,
    AgePipe,
    CustomerNominativePipe,
    FormatAddressPipe,
    FirstLetterPipe,
    GravatarUrlPipe,
    MentionsPipe,
    DayjsPipe,
    DayjsParsePipe,
    WeightPipe,
    MedicalImageViewerDirective,
    OpenHealthRecordTitlePipe,
    IconByFileTypePipe,
    SpeciesIconPipe,
    ColorByStringPipe,
    ColorByIndexPipe,
    ColorByIdPipe,
    InitialsPipe,
    TextToHtmlPipe,
    TruncatePipe,
    TruncateMiddlePipe,
    HtmlToTextPipe,
    PhonePipe,
    DateDiffPipe,
    SafeHtmlPipe,
    AbsPipe,
    CanPipe,
    StatePipe,
    CanBeActivatedPipe,
    NameDrugsPipe,
    MoneyPipe,
    ReplacePipe,
    AttachmentIsSignablePipe,
    AttachmentIsSignedPipe,
    StripHtmlPipe,
    ToFuncIdentityPipe
  ],
  declarations: [
    ArchiveIconPipe,
    BuildUrlWithFacilityPipe,
    DurationPipe,
    FileSizePipe,
    FirstLetterPipe,
    RandomArrayPipe,
    TodayOrDatePipe,
    PrintAddressPipe,
    AbsoluteUrlPipe,
    AgePipe,
    CustomerNominativePipe,
    FormatAddressPipe,
    GravatarUrlPipe,
    MentionsPipe,
    DayjsPipe,
    DayjsParsePipe,
    WeightPipe,
    MedicalImageViewerDirective,
    OpenHealthRecordTitlePipe,
    IconByFileTypePipe,
    SpeciesIconPipe,
    ColorByStringPipe,
    ColorByIndexPipe,
    ColorByIdPipe,
    InitialsPipe,
    TextToHtmlPipe,
    TruncatePipe,
    TruncateMiddlePipe,
    HtmlToTextPipe,
    PhonePipe,
    DateDiffPipe,
    SafeHtmlPipe,
    AbsPipe,
    CanPipe,
    StatePipe,
    CanBeActivatedPipe,
    NameDrugsPipe,
    MoneyPipe,
    ReplacePipe,
    AttachmentIsSignablePipe,
    AttachmentIsSignedPipe,
    StripHtmlPipe,
    ToFuncIdentityPipe
  ]
})
export class PipesModule {}
